import {
  RaffleWinnersStore,
  RaffleWinnersStoreProvider,
} from './RaffleWinnersStore';
import { RaffleWinners } from './RaffleWinners';

export const RaffleWinnersWrapper = () => {
  return (
    <RaffleWinnersStoreProvider store={new RaffleWinnersStore()}>
      <RaffleWinners />
    </RaffleWinnersStoreProvider>
  );
};
